import styled from 'styled-components';

import { TOTPInputSize } from '../types';

interface IStyledInputProps {
  inputSize: TOTPInputSize;
  hasError: boolean;
}

const getHeight: Record<TOTPInputSize, string> = {
  lg: '48px',
  md: '42px',
  sm: '36px',
};

export const StyledInput = styled.input<IStyledInputProps>`
  height: ${({ inputSize }) => getHeight[inputSize]};
  aspect-ratio: 1 / 1;

  background: ${({ theme }) => theme.colors.surface};
  border: ${({ theme, hasError }) =>
    `1px solid ${hasError ? theme.colors.danger : theme.colors.gray[100]}`};
  border-radius: ${({ theme }) => theme.borderRadius.sm};

  padding: ${({ theme, inputSize }) =>
    `0 ${inputSize === 'lg' ? theme.spacing.sm : '12px'}`};
  font-size: ${({ inputSize }) => (inputSize === 'sm' ? '12px' : '14px')};
  text-align: center;
  color: ${({ theme }) => theme.colors.onSurface};
  text-transform: uppercase;

  transition: all ease-in 0.3s;

  &:disabled {
    background-color: ${({ theme }) => theme.colors.gray[50]};
  }
`;
